var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.IndexPage,{attrs:{"parentData":{ grid: _setup.grid, path: _setup.path, grid_key: _setup.gridKey, report_class: _setup.reportClass }},on:{"set-loading":_setup.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }